"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_config_1 = require("react-router-config");
const react_router_dom_1 = require("react-router-dom");
const react_toastify_1 = require("react-toastify");
const LoadingSpinner_1 = __importStar(require("../../../common/js/components/LoadingSpinner"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const Paths = __importStar(require("../../constants/Paths"));
const Routes_1 = require("../../constants/Routes");
const history_1 = require("../../helper/history");
const path_1 = require("../../helper/path");
const resellerRoutes_1 = require("../../helper/resellerRoutes");
const routes_1 = require("../../helper/routes");
const ResellerAreaNavigationStore_1 = __importDefault(require("../../stores/ResellerAreaNavigationStore"));
const TabsNavigation_1 = __importDefault(require("../TabsNavigation"));
const ResellerAreaPage = ({ route, location, history, }) => {
    const definedRoutes = (0, react_1.useMemo)(() => (route?.routes ?? []), [route?.routes]);
    const resellerAreaRoutes = (0, react_1.useMemo)(() => (0, resellerRoutes_1.createRouteConfigFromResellerNavigationItems)(ResellerAreaNavigationStore_1.default.items), [ResellerAreaNavigationStore_1.default.items]);
    const beforeDefinedResellerAreaRoutes = (0, react_1.useMemo)(() => resellerAreaRoutes.slice(0, 1), [resellerAreaRoutes]);
    const afterDefinedResellerAreaRoutes = (0, react_1.useMemo)(() => resellerAreaRoutes.slice(1), [resellerAreaRoutes]);
    const allowedDefinedRoutes = (0, react_1.useMemo)(() => definedRoutes.filter((r) => {
        // noinspection JSDeprecatedSymbols
        const routeScopes = r.scopes ?? (r.scope ? [r.scope] : []);
        return AuthorizationStore_1.default.hasScopes(routeScopes);
    }), [definedRoutes, AuthorizationStore_1.default.customerId, AuthorizationStore_1.default.scopes]);
    const allowedRoutes = (0, react_1.useMemo)(() => [...beforeDefinedResellerAreaRoutes, ...allowedDefinedRoutes, ...afterDefinedResellerAreaRoutes], [allowedDefinedRoutes, beforeDefinedResellerAreaRoutes, afterDefinedResellerAreaRoutes]);
    const allowedFlatRoutes = (0, react_1.useMemo)(() => (0, routes_1.flattenRoutes)(allowedRoutes, false), [allowedRoutes]);
    const routes = (0, react_1.useMemo)(() => [...beforeDefinedResellerAreaRoutes, ...definedRoutes, ...afterDefinedResellerAreaRoutes], [definedRoutes, beforeDefinedResellerAreaRoutes, afterDefinedResellerAreaRoutes]);
    const [initialized, setInitialized] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!initialized || (0, react_router_config_1.matchRoutes)(allowedFlatRoutes, location.pathname).length > 0) {
            return;
        }
        const resellerRedirectPath = allowedFlatRoutes[0]?.path ?? null;
        if (null === resellerRedirectPath) {
            react_toastify_1.toast.error((0, translation_1.t)('reseller.unavailable'));
        }
        (0, history_1.pushHistory)(history, resellerRedirectPath ?? (0, path_1.localePath)(Paths.PATH_HOME));
    }, [allowedFlatRoutes, location.pathname, history, initialized]);
    (0, react_1.useEffect)(() => {
        ResellerAreaNavigationStore_1.default.loadNavigation().finally(() => {
            setInitialized(true);
        });
    }, []);
    return (react_1.default.createElement("section", { className: (0, classnames_1.default)('znd-reseller-page', {
            'd-flex flex-column flex-grow-1': !!(0, react_router_dom_1.matchPath)(location.pathname, Routes_1.ROUTE_RESELLER_FILES),
        }) },
        react_1.default.createElement("div", { className: "znd-top-page" },
            react_1.default.createElement("h1", { className: "znd-top-page__title t-headline-2" }, (0, translation_1.t)('reseller.title'))),
        ResellerAreaNavigationStore_1.default.isLoading || !initialized ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "znd-tabs position-relative" },
                react_1.default.createElement(LoadingSpinner_1.default, { style: LoadingSpinner_1.LoadingSpinnerStyle.small, center: true })),
            react_1.default.createElement(LoadingSpinner_1.default, { center: true }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TabsNavigation_1.default, { className: "znd-tabs__category-navigation", routes: routes }),
            (0, react_router_config_1.renderRoutes)(allowedFlatRoutes)))));
};
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scopes: [AuthorizationScopes_1.default.RESELLER_READ] })((0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(ResellerAreaPage))));
